<div class="service-type-container margin-top-8" cdkDropList (cdkDropListDropped)="drop($event)">
  <div *ngIf="loading" class="margin-top-8">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
  </div>
  <div *ngIf="!loading && Categories.length === 0 && !errorLoadingServerTypes" class="margin-top-16">
    {{ (showFittings ? 'bikeshop.service_types.no_categories_fittings' :
    'bikeshop.service_types.no_categories_service_types') | translate}}
  </div>

  <div *ngIf="errorLoadingServerTypes" class="margin-top-16 error-loading-service-types">
    <div>{{'bikeshop.service_types.error_loading_serviceTypes' | translate}}</div>
    <div class="row margin-top-16">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <button pButton type="button" class="p-button-raised accent" label="{{
          'bikeshop.service_types.clear_serviceTypes' | translate
        }}" (click)="bulkDeleteAll()" [disabled]="busyBulkActioning"></button>
      </div>
      <div class="col-md-4"></div>      
    </div>
  </div>

  <span *ngIf="Categories.length > 0" class="ml-3 mt-3"
    style="width: 44px;display: flex; justify-content: center;align-items: flex-start;">
    <p-checkbox [binary]="true" [(ngModel)]="globalSelectValue" [disabled]="busyBulkActioning"
      (onChange)="globalSelected($event)"></p-checkbox>
  </span>
  <span *ngIf="Categories.length > 0" class="ml-3 mt-3" style="flex: 0.5;">Service Name</span>
  <span *ngIf="Categories.length > 0" class="mt-3" style="flex: 0.5;">Technicians</span>
  <span *ngIf="Categories.length > 0" class="mt-3 ml-3" style="flex: 0.3;">Online Bookings</span>
  <span *ngIf="Categories.length > 0 && showFittings == true" class="mt-3 ml-3" style="flex: 0.3;">Fittings</span>
  <span *ngIf="Categories.length > 0" class="mt-3" style="flex: 0.3;">SKU Linked</span>
  <span *ngIf="Categories.length > 0" class="mt-3 mr-2" style="flex: 0.3;">Time</span>
  <span *ngIf="Categories.length > 0" class="mt-3 mr-3" style="flex: 0.3;">Cost</span>


  <div *ngFor="let category of Categories; let i = index" class="topCategory" id="{{category.name}}" cdkDrag>
    <div class="category" [ngClass]="{'border': categoryView, 'mt0': i===0}">
      <div class="category-indicator"></div>
      <div class="category-container">
        <div>
          <input *ngIf="category.editing" type="text" pInputText [(ngModel)]="categoryEditing" autofocus
            (blur)="changeCategoryName(i)" (keyup.enter)="changeCategoryName(i)" />
          <span class="service-type-name" *ngIf="!(category.editing)">
            {{ category.name || "Not Assigned" }}
          </span>
        </div>
      </div>
      <span *ngIf="category.name !== ''">
        <i class="fa fa-ellipsis-h" (click)="setOption(category.name)"></i>
        <div class="option-box" [ngClass]="{ hide: option !== category.name || category.editing}">
          <div class="option" (click)="addServiceType(category.name)">
            {{ (showFittings ? 'bikeshop.service_types.add_new_fitting' : 'bikeshop.service_types.add_new_service') |
            translate }}
          </div>
          <div class="option" *ngIf="!isCollections" (click)="setEditCategory(i)">
            {{ 'bikeshop.service_types.edit_category' | translate }}
          </div>
          <div class="option caution" *ngIf="category.deletable && !isCollections"
            (click)="deleteCategory(category.name)">
            {{ 'bikeshop.service_types.delete_category' | translate }}
          </div>
        </div>
      </span>
    </div>
    <span class="grow" *ngIf="open === category.name || open === 'all'"
      [ngClass]="{ 'no-height': categoryView || collapsedCategories.includes(category.name)}">
      <div *ngFor="let serviceType of serviceTypes[category.name]" (click)="editServiceType(serviceType)"
        class="clear-box">
        <span class="bulk-action-button" (click)="$event.stopPropagation()">
          <p-checkbox [(ngModel)]="serviceType.selected" [disabled]="busyBulkActioning" [binary]="true"></p-checkbox>
        </span>
        <span class="service-type-name" style="flex: 0.5;">{{serviceType.ServiceTypeDescription}}</span>
        <span style="flex:0.5;">
          <div class="technicians">
            <i *ngFor="let technician of serviceType.LinkedTechnicians">
              <avatar size=25 name="{{technician.Firstname+' '+technician.Surname}}" profilePhoto=""></avatar>
            </i>
          </div>
        </span>

        <!--          <div>-->
        <!--            &lt;!&ndash; <i *ngIf="serviceType.TechnicianLinked"-->
        <!--              pTooltip="{{ 'bikeshop.service_types.technician_linked' | translate }}" tooltipPosition="top"-->
        <!--              class="fa hubtiger-wrench" aria-hidden="true"></i> &ndash;&gt;-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <i pTooltip="{{ 'bikeshop.service_types.external_booking' | translate }}"-->
        <!--               [ngClass]="{'dimmed': !serviceType.Show}"-->
        <!--               tooltipPosition="top" class="fa hubtiger-calendar" aria-hidden="true"></i>-->
        <!--          </div>-->

        <span style="flex:0.3">
          <div pTooltip="{{ 'bikeshop.service_types.external_booking_label' | translate }}" class="chip"
            [ngClass]="{'negative-chip': !serviceType.Show}">
            <span class="chip-text" [ngClass]="{'negative-chip': !serviceType.Show}">
              <span *ngIf="!serviceType.Show">{{ 'bikeshop.general.disabled' | translate }}</span>
              <span *ngIf="serviceType.Show">{{ 'bikeshop.general.enabled' | translate }}</span>
            </span>
          </div>
        </span>

        <span *ngIf="showFittings == true" style="flex:0.3">
          <div>
            <i pTooltip="{{ 'bikeshop.service_types.bike_fitting' | translate }}"
              [ngClass]="{'dimmed': !serviceType.IsFitting}" tooltipPosition="top" class="fa hubtiger-measuring-tape"
              aria-hidden="true"></i>
          </div>

        </span>

        <span style="flex:0.3">
          <div class="chip" [ngClass]="{'negative-chip': !serviceType.skuLinked}">
            <span class="chip-text" [ngClass]="{'negative-chip': !serviceType.skuLinked}">
              <span *ngIf="!serviceType.skuLinked">{{
                'bikeshop.modal.add_edit_service_types.linked_technicians_form.unlinked' | translate }}</span>
              <span *ngIf="serviceType.skuLinked">{{
                'bikeshop.modal.add_edit_service_types.linked_technicians_form.linked' | translate }}</span>
            </span>
          </div>
        </span>
        <!--            <i pTooltip="{{ 'bikeshop.service_types.sku_linked' | translate }}"-->
        <!--               [ngClass]="{'dimmed': !serviceType.skuLinked}"-->
        <!--               tooltipPosition="top" class="fa fa-barcode" aria-hidden="true">-->
        <!--            </i>-->


        <span class="service-type-time" style="flex: 0.3;">
          <span>{{ serviceType.displayTime }}</span>
        </span>
        <span class="service-type-name" style="flex: 0.3;">
          <span>{{ currencySymbol }}{{ serviceType.Cost | number : '.2-2' }}</span>
        </span>
      </div>
    </span>
  </div>
</div>


<div class="bulk-action-container" [ngClass]="{'active': isServiceTypesSelected()}">
  <div *ngIf="busyBulkActioning" style="margin-top: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div *ngIf="!busyBulkActioning && linkedPartners && linkedPartners.length > 0">
    <button class="iso-round-button iso-light error-button" (click)="bulkCopy()" [disabled]="busyBulkActioning">{{
      'bikeshop.service_types.bulk_copy' | translate
    }}</button>
  </div>
  <div *ngIf="!busyBulkActioning">
    <button class="iso-round-button iso-light error-button" (click)="bulkDelete()" [disabled]="busyBulkActioning">{{
      'bikeshop.service_types.bulk_delete' | translate
    }}</button>
  </div>
</div>

<p-toast position="bottom-center" key="bottom-center" styleClass="hubtiger-toast"></p-toast>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>


<p-sidebar #NavSideBar [(visible)]="showServiceType" position="right"
  [style]="{width:'70em', background: '#F6F6F8', 'overflow-x': 'auto'}"
  (onHide)="getServiceTypes(); NavSideBar.destroyModal()">
  <div *ngIf="showServiceType">
    <app-add-edit-services [selectedServiceType]="selectedServiceType" [categoryOptions]="Categories"
      [technicians]="technicians" (closeSidePanel)="closeSidePanel()" [messageService]="messageService"
      [isFitting]="showFittings"></app-add-edit-services>
  </div>
</p-sidebar>

<p-confirmDialog></p-confirmDialog>

<p-dialog header="{{'bikeshop.service_types.bulk_copy' | translate}}" [modal]="true" [(visible)]="showBulkCopyDialog"
  [style]="{ width: '30rem' }">
  <span class="p-text-secondary bold">{{ 'bikeshop.service_types.bulk_copy_confirmation' | translate }}:</span>
  <div>
    <p-listbox [options]="linkedPartners" optionLabel="partnerName" optionValue="partnerID"
      [(ngModel)]="selectedPartners" [multiple]="true">

    </p-listbox>
  </div>
  <div class="row margin-top-16">    
    <div class="col-md-4">
      <button [disabled]="busyBulkActioning" class="iso-round-button" (click)="showBulkCopyDialog = false; selectedPartners = []">{{'general.cancel' | translate}}</button>
    </div>    
    <div class="col-md-2"></div>
    <div class="col-md-6">
      <button *ngIf="!busyBulkActioning" class="iso-round-button iso-light error-button" [disabled]="!selectedPartners || selectedPartners.length===0"
        (click)="startBulkCopy()">{{'bikeshop.service_types.copy_service_types' | translate}}</button>
      
      <div *ngIf="busyBulkActioning" style="margin-top: 16px;display: flex;justify-content: center;">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
          </p-progressSpinner>
        </div>
    </div>
  </div>
</p-dialog>